import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export function getPredityPropertyAdditionnalData(id) {
  const url = `${process.env.M2M_BASE_URI}/properties/${id}`;
  return Client.get(url)
    .then((response) => {
      return response.data.value[0];
    })
    .catch(errorHandler);
}
export function getPredityPropertyControllersData(id) {
  const url = `${process.env.M2M_BASE_URI}/properties/${id}/controllers`;
  return Client.get(url, {
    params: {
      $filter: "controller_type eq 'Automate'",
      $orderby: 'communication_status',
    },
  })
    .then((response) => {
      return response.data.value;
    })
    .catch(errorHandler);
}
export function getPredityPropertiesAdditionnalData(idList) {
  const url = `${process.env.M2M_BASE_URI}/properties`;
  return Client.get(url, {
    params: {
      property_ids: idList.map((num) => `${num}`).join(';'),
    },
  })
    .then((response) => {
      return response.data.value;
    })
    .catch(errorHandler);
}
